import { render, staticRenderFns } from "./Suscripcion.vue?vue&type=template&id=6c128362&scoped=true&lang=pug&"
import script from "./Suscripcion.vue?vue&type=script&lang=js&"
export * from "./Suscripcion.vue?vue&type=script&lang=js&"
import style0 from "./Suscripcion.vue?vue&type=style&index=0&id=6c128362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c128362",
  null
  
)

export default component.exports